import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  select {
    width: 100%;
    height: 52px;
    border-radius: 12px;
    border: 1px solid #ddd;
    padding: 0 12px;
    font-size: 16px;
    font-weight: 600;
    color: var(--textBlack, #525266);
    background: #fff;
    outline: none;
  }
  label {
    display: block;
    margin-bottom: 6px;
    font-size: 16px;
    color: var(--textBlack, #525266);
    font-weight: 500;
  }
`;

const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'IT', name: 'Italy' },
  { code: 'FR', name: 'France' },
  { code: 'ES', name: 'Spain' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'DE', name: 'Germany' },
  { code: 'AU', name: 'Australia' },
  { code: 'CA', name: 'Canada' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'MX', name: 'Mexico' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'BE', name: 'Belgium' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'BR', name: 'Brazil' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'IL', name: 'Israel' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KR', name: 'South Korea' },
  { code: 'GR', name: 'Greece' },
  { code: 'QA', name: 'Qatar' },
  { code: 'CN', name: 'China' },
  { code: 'MA', name: 'Morocco' },
  { code: 'SE', name: 'Sweden' },
  { code: 'AT', name: 'Austria' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'CO', name: 'Colombia' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'IE', name: 'Ireland' },
  { code: 'RO', name: 'Romania' },
  { code: 'NO', name: 'Norway' },
  { code: 'JP', name: 'Japan' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'AR', name: 'Argentina' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'EG', name: 'Egypt' },
  { code: 'IN', name: 'India' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AL', name: 'Albania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'HU', name: 'Hungary' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'RU', name: 'Russia' },
  { code: 'CL', name: 'Chile' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'JO', name: 'Jordan' },
  { code: 'DK', name: 'Denmark' },
  { code: 'HR', name: 'Croatia' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'SG', name: 'Singapore' },
  { code: 'FI', name: 'Finland' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'RS', name: 'Serbia' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'PH', name: 'Philippines' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'MT', name: 'Malta' },
  { code: 'PE', name: 'Peru' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'PA', name: 'Panama' },
  { code: 'GE', name: 'Georgia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'IS', name: 'Iceland' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'OM', name: 'Oman' },
  { code: 'GH', name: 'Ghana' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'PS', name: 'Palestine' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'LY', name: 'Libya' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'MD', name: 'Moldova' },
  { code: 'RE', name: 'Réunion' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AO', name: 'Angola' },
  { code: 'PF', name: 'French Polynesia' },
  { code: 'MC', name: 'Monaco' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GU', name: 'Guam' },
  { code: 'CI', name: "Côte d'Ivoire" },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'AD', name: 'Andorra' },
  { code: 'IM', name: 'Isle of Man' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GF', name: 'French Guiana' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'MQ', name: 'Martinique' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'LV', name: 'Latvia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'HN', name: 'Honduras' },
  { code: 'SM', name: 'San Marino' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'YE', name: 'Yemen' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'XK', name: 'Kosovo' },
  { code: 'EE', name: 'Estonia' },
  { code: 'IC', name: 'Canary Islands' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BQ', name: 'Caribbean Netherlands' },
  { code: 'VI', name: 'U.S. Virgin Islands' },
  { code: 'SX', name: 'Sint Maarten' },
  { code: 'BZ', name: 'Belize' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'IR', name: 'Iran' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'SN', name: 'Senegal' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NC', name: 'New Caledonia' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'AF', name: 'Afghanistan' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'AQ', name: 'Antarctica' },
  { code: 'KY', name: 'Cayman Islands' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'MO', name: 'Macao' },
  { code: 'MF', name: 'Saint Martin' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'MV', name: 'Maldives' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SY', name: 'Syria' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'GL', name: 'Greenland' },
  { code: 'TF', name: 'French Southern Territories' },
  { code: 'AX', name: 'Åland Islands' },
  { code: 'CK', name: 'Cook Islands' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'TC', name: 'Turks and Caicos Islands' },
  { code: 'TG', name: 'Togo' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'AW', name: 'Aruba' },
  { code: 'GN', name: 'Guinea' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'ML', name: 'Mali' },
  { code: 'NF', name: 'Norfolk Island' },
  { code: 'JE', name: 'Jersey' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'VG', name: 'British Virgin Islands' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'SR', name: 'Suriname' },
  { code: 'CG', name: 'Congo (Republic)'},
  { code: 'BF', name: 'Burkina Faso' }
];


const DeviceCountrySelect = ({ value, onChange }) => {
  return (
    <Wrapper>
      <label>Device country</label>
      <select value={value ?? 'US'} onChange={(event) => onChange(event.target.value)}>
        {COUNTRIES.map((country) => (
          <option key={country.code} value={country.code}>
            {country.name}
          </option>
        ))}
      </select>
    </Wrapper>
  );
};

export default DeviceCountrySelect;
